// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM
import Vue from 'vue';
import { AppConstants as _app } from '@/shared/app.constants';

const appUserType = _app.appUserType;

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        parentComponent: true,
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        actions: {
            listAction: "/api/User/GetUserDetail/",
            deleteAction: "/api/User/",
            updateAction: "/api/User",
            createAction: "/api/User",
        },
        formGroups: [
            {
                type: 'Fieldset',
                title: '',
                collapse: false,
                multiColumn: 2,
                create: [{
                    fieldNames: ['UserId', 'UserName', 'LoginName', 'UserTypeId', 'BusinessUnitId', 'EffectiveFrom', 'EffectiveTo', 'PreferredLanguageId', 'Active']
                }],
                edit: {
                    useCreate: true
                }
            },
            {
                type: 'Fieldset',
                title: 'Role information',
                collapse: false,
                multiColumn: 2,
                create: [{
                    fieldNames: ['UserRole']
                }],
                edit: {
                    useCreate: true
                }
            }
        ],
        fields: {
            UserId: {
                primaryKey: true
            },
            UserName: {
                required: true,
                weightage: 1,
                type: "TextInput",
                sortable: true,
                title: "User Name"
            },
            LoginName: {
                required: true,
                type: "TextInput",
                sortable: true,
                title: "Email"
            },
            UserTypeId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                sortable: true,
                title: "User Type",
                event: true,
            },
            RoleId: {
                required: true,
                type: "Hidden",
                // autocomplete: true,
                // sortable: true,
                title: "Default Role"
            },
            AuthenticationSettingsId: {
                required: true,
                type: "Hidden",
                // list: false,
                // autocomplete: true,
                title: "Authentication Type"
            },
            BusinessUnitId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                sortable: true,
                title: "Default Program"
            },
            EffectiveFrom: {
                required: true,
                displayCurrentDate: true,
                type: "Date",
                hint: 'DD/MM/YYYY',
                sortable: true,
                title: "Effective From"
            },
            EffectiveTo: {
                type: "Date",
                hint: 'DD/MM/YYYY',
                sortable: true,
                title: "Effective To"
            },
            // UserEmail: {
            //     required: true,
            //     list: false,
            //     type: "TextInput",
            //     title: "User Email"
            // },
            Password: {
                type: "Hidden"
            },
            ConfirmPassword: {
                type: "Hidden"
            },
            PreferredLanguageId: {
                required: true,
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Preferred Language"                
            },
            Active: {
                required: true,
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Active",
                defaultValue: 1
            },
            UserRole: {
                // required: true,
                type: "MultiSelect",
                chips: true,
                title: "User Roles"
            },
            UserImage: {
                type: "Hidden"
            },
            IsLocked: {
                type: "Hidden"
            },
            RequiredNotification: {
                type: "Hidden"
            },
            MailSent: {
                type: "Hidden"
            },
            DocumentStoreId: {
                type: "Hidden"
            },
            CreatedById: {
                type: "Hidden"
            },
            CreatedDate: {
                type: "Hidden"
            },
            UpdatedById: {
                type: "Hidden"
            },
            UpdatedDate: {
                type: "Hidden"
            },
            SysSchemaId: {
                type: "Hidden"
            },
            SysJSON: {
                type: "Hidden"
            },
            CusSchemaId: {
                type: "Hidden"
            },
            CusJSON: {
                type: "Hidden"
            },
            OriginBusinessUnitId: {
                type: "Hidden"
            },
            MaximumLoginAttempts: {
                type: "Hidden"
            },
            LastLoginDate: {
                type: "Hidden"
            },
            LastLogoutDate: {
                type: "Hidden"
            },
            LastLoginIp: {
                type: "Hidden"
            },
            QuestionId: {
                type: "Hidden"
            },
            Answer: {
                type: "Hidden"
            },
            PwdUpdatedDate: {
                type: "Hidden"
            },
            DashboardLayout: {
                type: "Hidden"
            },
            FirstLogin: {
                type: "Hidden"
            },
            MISDashlets: {
                type: "Hidden"
            },
            FavouriteMenu: {
                type: "Hidden"
            },
            FrequentMenu: {
                type: "Hidden"
            },
            LockedListValue: {
                type: "Hidden"
            },
            ReviseButton: {
                type: "Hidden"
            },
            UnlockButton: {
                type: "Hidden"
            }
        },
    },

    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
            let fields = payload.rootState.userFormIndex.fields;
            if (state.dashboard.componentId == 0) {
                fields.filter(x => x.value == 'LoginName').find(x => x).readonly = false;
                fields.filter(x => x.value == 'UserTypeId').find(x => x).readonly = false;
            }
        },

        //#. fn_formUpdated function
        formUpdated(state, payload) { },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
            let fields = payload.rootState.userFormIndex.fields;
            if (state.dashboard.componentId > 0) {
                // var userTypeId = state.data[0].UserTypeId;
                const appRoles = _app.appRoles;
                let userType = payload.payload.data.result.Record[0].UserTypeId;
                fields.filter(x => x.value == 'LoginName').find(x => x).readonly = true;
                //fields.filter(x => x.value == 'UserTypeId').find(x => x).readonly = true;

                payload.rootState.userPermissionsIndex.userPermissionCard = false;
                payload.rootState.userInitiativeMappingIndex.userInitiativeCard = false;
                payload.rootState.userReviewPanelMappingIndex.userReviewPanelCard = false;    

                switch (userType) {
                    case appUserType.Secretariat:
                        fields.filter(x => x.value == 'UserRole').find(x => x).create = true;
                        fields.filter(x => x.value == 'UserRole').find(x => x).edit = true;

                        payload.rootState.userPermissionsIndex.userPermissionCard = true;
                        payload.rootState.userInitiativeMappingIndex.userInitiativeCard = true;
                        break;

                    case appUserType.TAGReviewer:
                        fields.filter(x => x.value == 'UserRole').find(x => x).create = false;
                        fields.filter(x => x.value == 'UserRole').find(x => x).edit = false;

                        payload.rootState.userReviewPanelMappingIndex.userReviewPanelCard = true;
                        break;
                    
                    case appUserType.Auditor:
                        fields.filter(x => x.value == 'UserRole').find(x => x).create = true;
                        fields.filter(x => x.value == 'UserRole').find(x => x).edit = true;

                        payload.rootState.userInitiativeMappingIndex.userInitiativeCard = true;
                        break;

                    default:
                        fields.filter(x => x.value == 'UserRole').find(x => x).create = false;
                        fields.filter(x => x.value == 'UserRole').find(x => x).edit = false;
                        break;
                }

                payload.rootState.renderComponent = false;
                Vue.nextTick(() => {
                    // @ts-ignore
                    payload.rootState.renderComponent = true;
                });
            } else {
                fields.filter(x => x.value == 'LoginName').find(x => x).readonly = false;
                fields.filter(x => x.value == 'UserTypeId').find(x => x).readonly = false;
            }

        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        userTypeIdChange(state, payload) {
            const appRoles = _app.appRoles;
            let fields = payload.rootState.userFormIndex.fields;

            payload.rootState.userPermissionsIndex.userPermissionCard = false;
            payload.rootState.userInitiativeMappingIndex.userInitiativeCard = false;
            payload.rootState.userReviewPanelMappingIndex.userReviewPanelCard = false;

            switch (payload.payload.DisplayText) {
                case appUserType.Secretariat:
                    // payload.rootState.userFormIndex.orgFields.UserRole.dropdown
                    // state.userFormIndex.fields.UserRole.dropdown

                    // Checks whether the action is Create
                    if (state.dashboard.componentId == 0) {
                        // Set Secretariat Role by default
                    }

                    // let requiredRoles = [
                    //     // appRoles.ProgramAdmin,
                    //     // appRoles.InitiativeAdmin,
                    //     appRoles.GPOU,
                    // ]
                    // let roles = state.userFormIndex.fields.UserRole.dropdown;
                    // roles = roles.filter(i => requiredRoles.includes(i.Value.toString()));
                    // state.userFormIndex.fields.UserRole.dropdown = roles;

                    fields.filter(x => x.value == 'UserRole').find(x => x).create = true;
                    fields.filter(x => x.value == 'UserRole').find(x => x).edit = true;

                    payload.rootState.userPermissionsIndex.userPermissionCard = true;
                    payload.rootState.userInitiativeMappingIndex.userInitiativeCard = true;
                    break;

                case appUserType.TAGReviewer:
                    fields.filter(x => x.value == 'UserRole').find(x => x).create = false;
                    fields.filter(x => x.value == 'UserRole').find(x => x).edit = false;

                    payload.rootState.userReviewPanelMappingIndex.userReviewPanelCard = true;
                    break;
                
                case appUserType.Auditor:
    
                    // Checks whether the action is Create
                    if (state.dashboard.componentId == 0) {
                        // Set Secretariat Role by default
                    }
    
                    fields.filter(x => x.value == 'UserRole').find(x => x).create = true;
                    fields.filter(x => x.value == 'UserRole').find(x => x).edit = true;

                    payload.rootState.userInitiativeMappingIndex.userInitiativeCard = true;
                    break;

                default:
                    fields.filter(x => x.value == 'UserRole').find(x => x).create = false;
                    fields.filter(x => x.value == 'UserRole').find(x => x).edit = false;
                    break;
            }

            payload.rootState.userFormIndex.renderForm = false;
            Vue.nextTick(() => {
                // @ts-ignore
                payload.rootState.userFormIndex.renderForm = true;
            });
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },
        formUpdated: ({ commit, rootState }, payload) => {
            commit('formUpdated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        userTypeIdChange: ({ commit, rootState }, payload) => {
            commit('userTypeIdChange', { rootState, payload });
        },
    }
}
